"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoSuchKey = {
    type: "structure",
    required: [],
    members: {},
    exceptionType: "NoSuchKey"
};
//# sourceMappingURL=NoSuchKey.js.map